export default __webpack_public_path__ + "static/media/banner1.75c52f6e.jpg";